import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { Row } from "antd";
import { DataTable } from "@life-line-lab/components-react";
import DataTableFilter from "Components/shared/data-table-filter";
import useSearch from "Hooks/search.hook";
import { routeToOrderView } from "Helpers/route-order-view";
import { LastMileStatusEnum } from "Types/last_mile_status.types";
import { getStatusStyle } from "Helpers/get-status-colours";
import { toCapitalisedSpaced } from "Helpers/to-capitalised-spaced";

const LastMileCustomerList = ({ parcelList, onFilter }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const handleOpenOrderView = (orderID) => {
    const params = "module=delivery&tabKey=2";
    routeToOrderView(orderID, location, history, params);
  };

  const initialFilter: any = {
    status: "",
  };

  const [filterState, setFilterState] = useState<{
    [key: string]: string | boolean;
  }>(initialFilter);

  const initialFilterSelection = [
    {
      key: "status",
      name: "status",
      label: t("placeholder.byStatus"),
      placeholder: t("placeholder.byStatus"),
      value: filterState?.status,
      options: [
        { label: t("option.all"), value: "" },
        {
          label: t("label.deliveryNotPossible"),
          value: LastMileStatusEnum.DELIVERY_NOT_POSSIBLE,
        },
        {
          label: t("label.deliveryRefused"),
          value: LastMileStatusEnum.DELIVERY_REFUSED,
        },
        {
          label: t("label.deliveryInProgress"),
          value: LastMileStatusEnum.DELIVERY_IN_PROGRESS,
        },
        {
          label: t("label.returned"),
          value: LastMileStatusEnum.RETURNED,
        },
        {
          label: t("label.closed"),
          value: LastMileStatusEnum.CLOSED,
        },
        {
          label: t("label.unloaded"),
          value: LastMileStatusEnum.UNLOADED,
        },
      ],
    },
  ];

  const { handleSearch, handleFilterSelection } = useSearch({
    onFilter,
    filterState,
    setFilterState,
  });

  const columns: any = [
    {
      title: t("label.parcelOrderNo").toLocaleUpperCase(),
      dataIndex: "orderCode",
      width: 120,
      ellipsis: true,
      render: (orderCode: string, record: any) => {
        return <a className="clickable-id">{orderCode || ""}</a>;
      },
      onCell: (record: any) => {
        return {
          onClick: (e: React.MouseEvent<HTMLElement>) => {
            handleOpenOrderView(record._id);
          },
        };
      },
    },
    {
      title: t("label.parcelTrackingNo").toLocaleUpperCase(),
      dataIndex: "trackingNumber",
      width: 80,
      ellipsis: true,
    },
    {
      title: t("label.status").toLocaleUpperCase(),
      dataIndex: ["orderStatusInfo", "orderStatus"],
      width: 100,
      ellipsis: true,
      render: (status: string) => {
        return (
          <span className="status-indicator" style={getStatusStyle(status)}>
            {status ? toCapitalisedSpaced(status) : ""}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="parcel-order-list status-selector">
        <DataTable
          rowKey={(record: any) => {
            return record?._id;
          }}
          scroll={{ x: true }}
          columns={columns}
          dataSource={parcelList}
          title={() => (
            <Row className="filter-component">
              <DataTableFilter
                searchPlaceholder={t("placeholder.searchTrackingNo")}
                onSearch={(text: string) => {
                  handleSearch(text);
                }}
                onFilter={(selection) =>
                  handleFilterSelection({ status: selection.status })
                }
                renderFilterSelection={initialFilterSelection}
              />
            </Row>
          )}
        />
      </div>
    </>
  );
};

export default LastMileCustomerList;
